import { render } from "./DropDownMenu.vue?vue&type=template&id=2c4970be&scoped=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"

import "./DropDownMenu.vue?vue&type=style&index=0&id=2c4970be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4970be"]])

export default __exports__